import React, { ReactNode } from 'react';

import styles from './DividedContent.module.scss';

interface DividedContentProps {
  title?: ReactNode | null;
  children?: ReactNode | null;
}

const DividedContent = ({
  title = null,
  children = null,
}: DividedContentProps) => {
  return (
    <div className={styles.dividedContent}>
      <div className={styles.title}>{title}</div>
      <div className={styles.divider} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default DividedContent;
